import { openDocument } from '@/utils/wx_api'

export const goUrlPage = (url) => {
    if (url.search(/\.(png|jpg|jpeg|gif|bmp)/) > -1) {
        wx.previewImage({
            current: url,
            urls: [url],
        })
        return
    }
    // if (url.search(/\.(pdf|doc|docx)/) > -1) {
    //     openDocument(url)
    //     return
    // }
    // 放置二维码 后续加
    const jump_url = `/web_page?link=${encodeURIComponent(url)}&title=`
    wx.navigateTo({
        url: jump_url
    })
}